export default __webpack_public_path__ + "static/media/Rocks_carousel.c1da7d88.png";